import React from 'react';
import styled, { css } from 'styled-components';
import { mixins } from '../../css';
import Grid from '../../Utility/Grid';

export const StyledHeading = styled(Grid.Col)`
  && {
    padding: ${mixins.pxToRem(120)} 0 ${mixins.pxToRem(60)} 0;
    text-align: center;
  }
`;

const spreadGrid = ({ backgroundColor, backgroundImage, ...rest }) => <Grid.Container {...rest} />;
export const StyledSlide = styled(spreadGrid)`
  ${props =>
    props.backgroundImage &&
    css`
      background-image: ${`url(${props.backgroundImage})`};
    `};
  background-color: ${props => props.backgroundColor};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-bottom: ${mixins.pxToRem(175)};
`;

export const StyledImageColumn = styled(Grid.Col)`
  padding: ${mixins.pxToRem(45)} 0 0 0;
`;

export const StyledImageContainer = styled.div`
  max-width: 200px;
`;
